<template>
    <b-modal size="md" button-size="sm" hide-footer v-model="modalAberto" :title="prefix + title" @hidden="cancelar">

        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">

                    <b-form-row>
                        <LgFormInput v-model="form.descricao" label="Descrição*:" placeHolder="" description=""
                            invalidFeedback="Descrição deve ser informada!" />
                    </b-form-row>

                    <b-form-group label="Situação*:">
                        <b-form-radio-group v-model="form.situacao" :options="optionsSituacao"
                            name="radio-inline"></b-form-radio-group>
                    </b-form-group>

                    <div class="d-flex justify-content-center mt-3">
                        <b-button id="salvarLote" type="submit" variant="success" style="height: 30px" pill size="sm"
                            @click="save">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvarLote" title="Salvar"></b-tooltip>
                            </div>
                        </b-button>
                        <b-button id="cancelarCadastroLote" class="ml-2" @click="cancelar" style="height: 30px" pill
                            size="sm" variant="danger">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelarCadastroLote" title="Cancelar"></b-tooltip>
                            </div>
                        </b-button>
                    </div>
                </b-card>
            </b-card-body>
        </b-card>
    </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin } from "@/core/mixins/resource"

export default {
    components: {
        LgFormInput,
    },

    props: {
        id: Number,

        prefix: {
            type: String,
            default: "",
        },

        produto: {
            type: Object,
            default: null,
            required: true,
        },
        almoxarifado: {
            type: Object,
            default: null,
            required: true,
        },
        title: {
            type: String,
            default: "Cadastro",
        },
    },

    mixins: [FormResourceMixin],
    validations: {
        form: {
            descricao: { required },
            situacao: { required },
        },
    },

    data() {
        return {
            modalAberto: true,
            form: {
                descricao: "",
                produto: {},
                situacao: 1,
                almoxarifado: {},
            },
            optionsSituacao: [
                { value: 1, text: "Ativo" },
                { value: 0, text: "Inativo" },
            ],
        }
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/lote`);

        if (this.id) {
            this.busy = true;
            const { data } = await this.$service.findById(this.id);
            this.busy = false;
            this.form = data;
        }

    },

    methods: {
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch()
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos obrigatórios!",
                })
                return
            }

            let filtro = {}

            filtro.produtoId = this.produto.id
            filtro.almoxarifadoId = this.almoxarifado.id
            filtro.descricao = this.form.descricao
            filtro.situacao = this.form.situacao
            filtro.id = this.form.id;
            try {
                await this.$saveResource(filtro, "", true, {}, false, true);
                this.cancelar();
            }
            catch (error) {
                this.$notify({
                    type: 'danger',
                    message: error.response.data,
                });
            }
        },

        cancelar() {
            this.modalAberto = false
            this.$emit("close")
        },
    },
}
</script>
